import AdvantageDisadvantageSvg from './AdvantageDisadvantageSvg';

export default AdvantageDisadvantageSvg;
export { AdvantageDisadvantageSvg };
